<template>
  <div style="background-color: #fff;">
    <van-nav-bar
      :title="generateCustomizeString('checkOrder')"
      :left-text="generateCustomizeString('goBack')"
      left-arrow
      @click-left="onClickLeft"
      :sticky="true"
      fixed
    >
      <!-- <van-icon name="aim" slot="right" /> -->
      <img
        slot="right"
        :src="scan"
        style="width: 18px; vertical-align: middle;"
        @click="scanBarCode"
      />
    </van-nav-bar>
    <div style="margin-top: 46px; margin-bottom: 100px; padding: 10px 0;">
      <van-list class="goods-list" v-for="goods in orderProductData" :key="goods.id">
        <van-row>
          <van-col span="6" style="padding-top: 32px; text-align: center;">
            <van-checkbox v-model="goods.checked" v-if="goods.numOfGoods === goods.amount">
              <!-- <van-icon class="checked" slot="icon" name="success" /> -->
              <!-- <span v-if="goods.checked === true" style="color: #FFA800;">{{goods.amount}}</span> -->
              <span>{{goods.numOfGoods}}</span>
              <span style="color: #FFA800;">/ {{goods.amount}}</span>
            </van-checkbox>
            <van-checkbox v-model="goods.checked" v-else>
              <span v-if="goods.checked === true" style="color: #FFA800;">{{goods.amount}}</span>
              <span v-else>{{goods.numOfGoods}}</span>
              <span style="color: #FFA800;">/ {{goods.amount}}</span>
            </van-checkbox>
          </van-col>
          <van-col span="18">
            <van-row class="goods-item" style="display: flex;">
              <van-col
                span="8"
                style="height: 100%; position: relative; text-align: center; margin: auto;"
              >
                <img class="thumbnail" v-lazy="goods.productThumbnailUrl" />
              </van-col>
              <van-col span="15" style="margin-left: 5px;">
                <div class="title">{{goods.productTitle}}</div>
                <div class="bar-code">{{generateCustomizeString('barCode')}} {{goods.productId}}</div>
                <div
                  class="expiry-date"
                >">{{generateCustomizeString('bestBefore')}} {{goods.bestBefore}}</div>
                <div class="price">
                  <span>{{goods.unitPrice}}</span>
                </div>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </van-list>
    </div>
    <div style="position: fixed; bottom: 50px; width: 100%;" v-if="this.allChecked !== true">
      <van-button
        type="primary"
        size="large"
        @click="scanBarCode"
      >{{generateCustomizeString('scanBarCode')}}</van-button>
    </div>
    <div style="position: fixed; bottom: 0; width: 100%;">
      <van-button
        type="primary"
        size="large"
        @click="submit"
        v-if="this.allChecked === true"
      >{{generateCustomizeString('submit')}}</van-button>
      <van-button
        type="default"
        size="large"
        @click="cancel"
        v-else
      >{{generateCustomizeString('cancel')}}</van-button>
    </div>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import {
  Row,
  Col,
  Tag,
  Panel,
  Button,
  Field,
  NavBar,
  List,
  Cell,
  CellGroup,
  Toast,
  Checkbox,
  Icon
} from 'vant'
import request from '@/utils/request'
import wxConfig from '@/utils/wxConfig'
import scan from '@/assets/scan.png'

export default {
  name: 'OrderCheck',
  data() {
    return {
      orderProductData: [],
      numOfGoods: 0,
      scan: scan
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Panel.name]: Panel,
    [Button.name]: Button,
    [Field.name]: Field,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon
  },
  computed: {
    allChecked: function() {
      var num = 0
      for (var i = 0; i < this.orderProductData.length; i++) {
        if (this.orderProductData[i].checked === true) {
          num += 1
        }
      }
      if (this.orderProductData.length === num) {
        return true
      }
      return false
    }
  },
  methods: {
    generateCustomizeString,
    onClickLeft() {
      this.$router.push({
        name: 'OrderDetail',
        params: { orderId: this.$route.params.orderId }
      })
    },
    cancel() {
      this.$router.go(-1)
    },
    scanBarCode() {
      const that = this
      wxConfig.scanQRCode().then(key => {
        let verifyFlag = false
        for (var i = 0; i < that.orderProductData.length; i++) {
          const tmpBarCode = that.orderProductData[i].productId
          if (tmpBarCode.trim() === key.trim()) {
            verifyFlag = true
            if (that.orderProductData[i].checked === true) {
              Toast.fail(this.generateCustomizeString('finishCheck'))
              return
            } else {
              that.orderProductData[i].numOfGoods += 1
            }
          }

          if (
            that.orderProductData[i].numOfGoods ===
            that.orderProductData[i].amount
          ) {
            that.orderProductData[i].checked = true
          }
        }
        if (!verifyFlag) {
          Toast.fail(this.generateCustomizeString('noMatchGoods'))
        }
      })
    },
    submit() {
      request({
        url: 'order/' + this.$route.params.orderId + '/verify-goods',
        method: 'post'
      })
        .then(response => {
          if (response.status === 0) {
            Toast.success(this.generateCustomizeString('checkSuccess'))
            setTimeout(() => {
              this.$router.push({ name: 'OrderDetail' })
            }, 1000)
          } else {
            Toast.fail(this.generateCustomizeString('checkFail'))
          }
        })
        .catch(error => {
          console.log(error)
          Toast.fail(this.generateCustomizeString('checkFail'))
        })
    },
    fetchOrderGoods() {
      request({
        url: 'order/' + this.$route.params.orderId,
        method: 'get'
      })
        .then(response => {
          const orderGoods = response.data.order_goods
          // const data = orderGoods
          const data = []

          for (let i = 0; i < orderGoods.length; i++) {
            var obj = {
              checked: false,
              numOfGoods: 0,
              productThumbnailUrl: '',
              productTitle: '',
              productId: '',
              bestBefore: '',
              unitPrice: '',
              amount: '',
              total: ''
            }
            obj.checked = false
            obj.numOfGoods = 0
            if (orderGoods[i].first_image_url) {
              obj.productThumbnailUrl =
                orderGoods[i].first_image_url +
                '?imageView2/0/w/128/h/128/q/75|imageslim'
            }
            obj.productTitle = orderGoods[i].product_full_name
            obj.productId = orderGoods[i].bar_code
            if (orderGoods[i].best_use_before_at !== null) {
              obj.bestBefore = orderGoods[i].best_use_before_at
            } else {
              obj.bestBefore = this.generateCustomizeString('new')
            }
            obj.unitPrice =
              'NZD $' + parseFloat(orderGoods[i].order_price / 100).toFixed(2)
            obj.amount = orderGoods[i].quantity
            obj.total =
              'NZD $' +
              parseFloat(
                (orderGoods[i].order_price * orderGoods[i].quantity) / 100
              ).toFixed(2)

            data.push(obj)
          }
          this.orderProductData = data
        })
        .catch(error => {
          console.warn(error)
        })
    }
  },
  created: function() {
    this.fetchOrderGoods()
    // wxConfig.config()
  }
}
</script>

<style lang="less" scoped>
.checked {
  color: #fff;
  border-color: #06bf04;
  background-color: #06bf04;
  border-radius: 100%;
  text-align: center;
  line-height: inherit;
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  font-size: 12px;
}
.goods-list {
  margin: 0 0.5rem 0 0.5rem;
  padding-top: 5px;
  padding-bottom: 5px;
  height: auto;
  border-bottom: 1px #eee solid;
}
.goods-item {
  height: 100%;
  padding: 5px 0;
  // overflow: auto;
  // position: relative;
  // text-align: left;
  // padding-left: 0rem;
  // vertical-align: middle;
}
.title {
  // margin: 0.3rem 0 0.3rem 4.5rem;
  font-size: 0.7rem;
  line-height: 1rem;
  // left: 1rem;
  // position: absolute;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box;
  // display: flex;
  // -webkit-box-orient: vertical;
  // -webkit-line-clamp: 2;
}
.thumbnail {
  background: #f5f5f5;
  // position: absolute;
  width: 5rem;
  height: 5rem;
  // top:0.3rem;
  // left:0.3rem;
}
.price {
  color: #ffa800;
  font-weight: 700;
  line-height: 1rem;
  font-size: 0.8rem;
  // margin-left: 5.5rem;
  // bottom: 0.5rem;
  // top: 3.4rem;
  // position: absolute;
}
.expiry-date {
  // position: absolute;
  // left: 5.5rem;
  // top: 3.4rem;
  font-size: 0.7rem;
  line-height: 1rem;
}
.bar-code {
  // position: absolute;
  // left: 5.5rem;
  // top: 2.5rem;
  font-size: 0.7rem;
  line-height: 1rem;
}
</style>
